/**
 * @typedef {Object} InteractiveBridge.View
 * @property {boolean} fullscreen
 * @property {'portrait' | 'landscape'} orientation
 * @property {number} width
 * @property {number} height
 */

/**
 * @typedef {Object} Message.Resize
 * @property {InteractiveBridge.View} view
 * @property {*} zones
 */

/**
 *
 * @param pConfig
 * @param pIframe
 * @param pZones
 * @return {Message.Resize}
 */
export default function createResizeMessage (pConfig, pIframe, pZones) {
  return {
    view: {
      fullscreen: pConfig.deviceType === "web" ? document.fullscreenElement !== null : true,
      orientation: window.innerHeight > window.innerWidth ? 'portrait' : 'landscape',
      width: 0, //pIframe.clientWidth,
      height: 0, //pIframe.clientHeight
    },
    zones: pZones,
  };
}
